import { Card, Typography } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface ExtrasCardProps {
  booking: BookingDetails;
}

export const ExtrasCard = ({ booking }: ExtrasCardProps) => {
  const { extras } = booking;

  if (!extras || extras.length === 0) {
    return null;
  }

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField
        leading={
          <div className="flex h-6 w-6 items-center justify-center">
            <div className={`h-[10px] w-[10px] rounded-full border-2 border-neutral-dark-gray`} />
          </div>
        }
        label="Extras"
        value={
          <div className="space-y-2">
            {extras.map((extra, index) => (
              <Typography key={index} variant="paragraph">
                {extra.name}
              </Typography>
            ))}
          </div>
        }
      />
    </Card>
  );
};
